import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  containerModal: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.4)',
    justifyContent: 'flex-end',
  },
  containerFilter: {
    height: 600,
    width: '95%',
    backgroundColor: 'white',
    alignSelf: 'center',
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    paddingVertical: 45,
  },
  spaceHorizontal: {
    paddingHorizontal: 25,
  },
  iconX: {
    alignSelf: 'flex-end',
  },
  information: {
    fontSize: 12,
    fontFamily: 'TCCC-UnityHeadline Regular',
    paddingHorizontal: 25,
    textAlign: 'center',
    maxWidth: 280,
    alignSelf: 'center',
    marginTop: 20,
  },
  filterText: {
    fontSize: 16,
    fontFamily: 'TCCC-UnityText Bold',
    lineHeight: 19,
    color: 'black',
    marginTop: 20,
  },
  filterOption: {
    fontSize: 14,
    paddingVertical: 5,
    color: 'black',
  },
  orderOption: {
    fontSize: 14,
    paddingVertical: 5,
  },
  activeText: {
    color: 'red',
  },
  containerDrop: {
    marginTop: 30,
  },
  containerButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 45,
    marginTop: 50,
  },
});
